import UnpublishErrorIcon from '@/assets/svg/unpublish-error.svg?react';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import type { ErrorCodeMessageType } from '@/shared/constant/error/ErrorCodeMessageType';
import clsx from 'clsx';

export type UnpublishErrorProps = {
  value: ErrorCodeMessageType;
  className?: string;
};

export function UnpublishError(props: UnpublishErrorProps) {
  const { className } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  return (
    <div
      className={clsx(
        'flex w-auto flex-col items-center justify-center max-os:p-5 os:w-[480px]',
        className,
      )}
    >
      <UnpublishErrorIcon />

      <div className="align-center mt-8 flex justify-center text-center text-2xl font-semibold text-color">
        {clientI18n('apidoc.unPublish')}
      </div>

      <div className="align-center mt-2 text-center text-lg font-400 text-secondary">
        {clientI18n('apidoc.unPublish.subTitle')}
      </div>
    </div>
  );
}
